import { accessCriteria } from '../util/authorization/index';
import { authRoles } from './roleGroups';

const DOCUMENT_TITLE = 'Tax Comments';

export const TaxCommentsRoutes = [
  {
    path: '/tax/comments',
    name: 'Tax-comments',
    meta: {
      title: DOCUMENT_TITLE,
    },
    component: () => import('../views/TaxComments.vue'),
    children: [
      {
        path: 'commentsearch',
        name: 'Tax - Comments Search',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/tax/Comments/CommentSearch.vue'),
      },
    ],
  },
];

TaxCommentsRoutes.forEach((element, index) => {
  TaxCommentsRoutes[index].beforeEnter = async (to, from, next) => {
    await accessCriteria([...authRoles.TaxRead, ...authRoles.TaxAuth], next);
  };
});

export default TaxCommentsRoutes;
